export default {
  greeting: "hi,{name}",
  components: {
    head1: {
      title: {
        login: "Login",
        register: "Register",
        forget: "Forgot Password",
      },
      intro1: "Industrial Products Digitalization",
      intro2: "Procurement Service Platform",
      right1: "Back to Login",
      right2: "Already have an account?",
      right3: "Please log in",
    },
    head2: {
      welcome_to_roke: "Welcome to ROKE",
      login_prompt: "Please log in",
      free_register: "Free Register",
      welcome: "Welcome",
      welcome_name: "Welcome, {name}",
      logout: "Log out",
      message: "Messages",
      latest_messages: "Latest Messages",
      no_messages: "No messages",
      view_all: "View All",
      my_orders: "My Orders",
      all_orders: "All Orders",
      pending_payment: "Pending Payment",
      pending_shipment: "Pending Shipment",
      pending_receipt: "Pending Receipt",
      completed: "Completed",
      aftersale: "My After-sales",
      personal_center: "Personal Center",
      order_center: "Order Center",
      invoice: "Invoice",
      invoice_info: "Invoice Info",
      apply_invoice: "Apply Invoice",
      my_invoice: "My Invoices",
      records: "Records",
      browse_history: "Browsing History",
      my_collection: "My Favorites",
      product_review: "Product Reviews",
      settings: "Settings",
      my_info: "My Information",
      company_info: "Company Information",
      addresses: "Address Management",
      usage_guide: "Usage Guide",
      guide_how_to_order: "How to Order",
      guide_view_order_progress: "View Order Progress",
      guide_shipping_fee: "Shipping Fee Policy",
      guide_after_sale_policy: "After-sales Policy",
      guide_how_to_apply_invoice: "How to Apply Invoice",
      guide_contact_us: "Contact Us",
      platform_intro:
        "Industrial Products Digitalization<br />Procurement Service Platform",
      search_placeholder: "Please enter product name",
      search: "Search",
      shopping_cart: "My Shopping Cart",
      cate_name: "All Products",
      language: "语言",
      lang_zh: "中文",
      lang_en: "English",
    },
    foot1: {
      text1: "Su Public Network Security No. 31000000000000",
      text2:
        "Copyright© zkh.com 1998-2024 Corporation All Rights Reserved Su ICP No. 10008888 Nantong ROKE Fluid Equipment CO.,LTD",
    },
    foot2: {
      perk1: {
        title: "Genuine Sources",
        text: "Authenticity guarantee · Trusted service",
      },
      perk2: {
        title: "Delivery Guarantee",
        text: "Own factories · On-time delivery",
      },
      perk3: {
        title: "Dedicated Support",
        text: "Quick response · Quotation support",
      },
      perk4: {
        title: "Exclusive Pricing",
        text: "Factory wholesale · Better prices",
      },
      shoppingGuide: "Shopping Guide",
      guideUsage: "Usage Guide",
      payMethods: "Payment Methods",
      payInvoiceInfo: "Payment & Invoice Info",
      howToPay: "How to Pay",
      servicePolicy: "Service Policies",
      userAgreement: "User Agreement",
      privacyPolicy: "Privacy Policy",
      saleService: "After-sales Service",
      contentCenter: "Content Center",
      latestInfo: "Latest News",
      importantNotice: "Important Notices",
      sampleDownload: "Sample Downloads",
      personalCenter: "Personal Center",
      orderManage: "Order Management",
      invoiceManage: "Invoice Management",
      aboutUs: "About Us",
      platformIntro: "Platform Introduction",
      contactUs: "Contact Us",
      platformTagline: "Digital Industrial Products Service Platform",
      workTime: "Working Hours: Mon–Fri 8:30~17:30",
      customerWechat: "Customer Service WeChat",
      publicSecurity: "Su Public Network Security No. 31000000000000",
      copyright:
        "Copyright© zkh.com 1998-2024 Corporation All Rights Reserved Su ICP No. 10008888 Nantong ROKE Fluid Equipment CO.,LTD",
    },
    addressPopup: {
      title: "Add Shipping Address",
      labelName: "Name:",
      placeholderName: "Up to 20 characters",
      labelPhone: "Phone:",
      placeholderPhone: "Please enter phone number",
      labelAddress: "Address:",
      selectProvince: "Please select province",
      selectCity: "Please select city",
      selectArea: "District/County/Street",
      labelDetailAddress: "Detailed Address:",
      placeholderDetailAddress: "Please enter detailed address",
      labelZipcode: "Zip Code:",
      placeholderZipcode: "If unknown, enter 000000",
      labelIsDefault: "Set as default?",
      textDefaultAddress: "Default shipping address",
      btnSave: "Save",
      btnCancel: "Cancel",
    },
    calendar: {
      week1: "Mon",
      week2: "Tue",
      week3: "Wed",
      week4: "Thu",
      week5: "Fri",
      week6: "Sat",
      week7: "Sun",
    },

    index: {
      prompt_title: "ROKE Fluid 2024 Indonesia Maritime Exhibition",
      prompt_link: "Click for details",
      banner_all_categories: "All Product Categories",
      welcome_hello: "Hello, welcome",
      welcome_line2: "to ROKE Industrial Products Mall!",
      login: "Login",
      enjoy_discount: "Enjoy discounts",
      register_btn: "Free Register",
      welcome_banner: "Welcome to ROKE Industrial Products Mall!",
      hello_prefix: "Hello!",
      account_security: "Account security: Medium",
      change_password: "Change Password",
      more_details: "More details",
      recommended_products: "Recommended Products",
      latest_info: "Latest News",
      important_notice: "Important Notices",
      view_all: "View All >",
      fixed_login: "Login",
      fixed_cart: "Cart",
      fixed_collection: "Favorites",
      fixed_guide: "Guide",
      fixed_customer_service: "Customer Service",
      fixed_back: "Back",
      btn_my_orders: "My Orders",
      btn_my_collection: "My Favorites",
      btn_invoice_manage: "Invoice Management",
      btn_usage_guide: "Usage Guide",
    },

    pagination: {
      next: "Next >>",
    },

    popupInvoice: {
      title: "Invoice Information",
      invoice_type: "Invoice Type:",
      char_special: "S",
      type_special: "Special Invoice",
      char_general: "G",
      type_general: "General Invoice",
      invoice_head: "Invoice Title:",
      invoice_taxno: "Taxpayer ID:",
      invoice_register_address: "Register Address:",
      invoice_register_mobile: "Register Phone:",
      invoice_branch: "Bank Branch:",
      invoice_accountno: "Bank Account:",
      btnSave: "Save",
      btnCancel: "Cancel",
    },
    my: {
      leftTitle: "My Center",
      orderCenter: "Order Center",
      order_my: "My Orders",
      aftersale: "My After-sales",
      invoice: "Invoice",
      invoice_info: "Invoice Info",
      apply_invoice: "Apply Invoice",
      my_invoice: "My Invoices",
      history: "History",
      browse_history: "Product Browsing History",
      collection: "Favorites",
      my_collection: "My Favorites",
      message: "Messages",
      messages_overview: "Messages Overview",
      comment: "Review",
      uncomment: "Items to Review",
      commented: "Reviewed Items",
      settings: "Settings",
      my_info: "My Information",
      company_info: "Company Information",
      addresses: "Address Management",
    },
  },
  pages: {
    login: {
      validation: {
        phone_required: "E-Mail is required",
        password_required: "Login password is required",
        code_required: "Verification code is required"
      },
      tab1: "Verification Code Login",
      tab2: "Account Login",
      phoneNumber: "E-Mail",
      phonePlaceholder: "Please enter your E-Mail",
      password: "Password",
      passwordPlaceholder: "Please enter your password",
      verifyCode: "Verification Code",
      codePlaceholder: "Please enter the verification code",
      getCode: "Get Verification Code",
      reGetCCode: "Resend in {time} seconds",
      loginBtn: "Login",
      register: "Free Register",
      forgetPwd: "Forgot Password?",
    },
    register: {
      title1: "Welcome to Register",
      title2: " ROKE ",
      title3: "Industrial Products Mall!",
      phoneLabel: "Phone Number",
      phonePlaceholder: "Please enter your phone number",
      verifyCodeLabel: "Verification Code",
      codePlaceholder: "Please enter the verification code",
      getCode: "Get Verification Code",
      reGetCCode: "Resend in {time} seconds",
      countryLabel: "Country",
      enterpriseLabel: "Enterprise Name",
      enterprisePlaceholder: "Please enter enterprise name",
      contactLabel: "Contact Name",
      contactPlaceholder: "Please enter contact name",
      emailLabel: "Email Address",
      emailPlaceholder: "Please enter email address",
      submitBtn: "Register",
      agree1: "I have read and agree to ",
      agree2: '"User Registration Agreement"',
      agree3: '"ROKE Privacy Policy"',
      please_accept: "Please read and accept the agreement",
      register_success: "Registration successful",
      register_fail: "Registration failed",
      pageTitle: "Account Registration",
    },
    pay: {
      tab_online: "Online Payment",
      tab_done: "Done",
      order_submitted_msg:
        "Order submitted successfully. Please pay promptly so we can arrange shipment as soon as possible!",
      order_no: "Order No:",
      order_amount: "Order Amount:",
      countdown1: "(Please complete payment within ",
      countdown2: "{hours} hours",
      countdown3: "{minutes} minutes",
      countdown4: "{seconds} seconds",
      countdown5: ", otherwise the order will be automatically canceled!)",
      paid_success:
        "Your order has been paid successfully. Please wait patiently for shipment!",
      open_alipay: "Open Alipay on your phone",
      scan_to_pay: "Scan to continue payment",
      ive_paid_view_order: "I've paid, view order",
      open_wechat: "Open WeChat on your phone",
      proceed_to_pay: "Proceed to Pay",
    },
    info: {
      breadcrumb: "Home  > Latest News > View More",
      breadcrumb2: "Home  > Important Notices > View More",
      published: "Published: ",
      views: "{count} views",
      hot_recommend: "Hot Recommendations",
      previous: "Previous",
      next: "Next >",
    },
    appraisal: {
      breadcrumb: "Home > Personal Center > Reviews > Reviewed Items",
      title: "Review Details",
      platform_order_no: "Platform Order No: ",
      order_time: "Order Time: ",
      evaluation_time: "Review Time",
      product_score: "Product Rating",
      evaluation_content: "Review Content",
      share_images: "Shared Images",
      score_format: "{score} points",
    },
    category: {
      sort_title_template:
        "Home > {name} Category > {name} Category Product List",
      all_list: "All Categories",
      all_products_category: "All Product Categories",
      path_three: "{first} > {second} > {third}",
      path_two: "{first} > {second}",
      path_one: "{first}",
    },
    car: {
      breadcrumb: "Home  >   Shopping Cart",
      cart_title: "Shopping Cart",
      search_placeholder: "Enter keywords to search products in cart",
      search_btn: "Search",
      th_select: "Select",
      th_item_info: "Product",
      th_spec_param: "Specs/Params",
      th_unit_price: "Unit Price",
      th_quantity: "Quantity",
      th_subtotal: "Subtotal",
      th_actions: "Actions",
      incl_tax: "(incl. tax)",
      excl_tax: "(excl. tax)",
      collect: "Collect",
      delete: "Delete",
      select_all: "Select All",
      delete_selected: "Delete Selected",
      total_summary: "Selected: {count} items  Total (incl. tax): ￥{amount}",
      pay_btn: "Checkout",
      confirm_delete_message: "Confirm remove this product from cart?",
      confirm_title: "Notice",
      confirm_confirm: "Confirm",
      confirm_cancel: "Cancel",
      select_products_warning: "Please select products!",
    },
    comment: {
      breadcrumb:
        "Home  >   Personal Center   >   Reviews   >   Pending Reviews",
      title: "Review Details",
      platform_order_no: "Platform Order No: ",
      order_time: "Order Time: ",
      product_score: "Product Rating",
      evaluation_content: "Review Content",
      share_images: "Shared Images",
      textarea_placeholder:
        "Share your experience to help others make a better decision~",
      delete: "Delete",
      tip_text:
        "Total <span>{count}</span> images, you can upload <span>{max}</span> more",
      submit_btn: "Submit Review",
      anonymous_label: "Anonymous Review",
      image_type_error: "Invalid image type!",
      image_size_error: "Image size must not exceed 5MB!",
      image_max_error: "You can upload up to {max} images!",
    },
    confirmOrder: {
      breadcrumb: "Home  >   Shopping Cart > Order Confirmation",
      steps: {
        pick: "Pick",
        submit: "Submit Order",
        done: "Done",
      },
      address_title: "Shipping Address",
      add_address_btn: "+ Add Shipping Address",
      no_address: "No shipping address yet, please {add}",
      add: "add",
      default: "Default",
      edit: "Edit",
      delete: "Delete",
      set_default: "Set as default shipping address",
      more_addresses: "More addresses ({count})",
      invoice_title: "Invoice Information",
      invoice_type_special: "Special Invoice",
      invoice_type_general: "General Invoice",
      add_invoice: "+ Add Invoice Info",
      invoice_head: "Invoice Title: ",
      invoice_taxno: "Taxpayer ID: ",
      invoice_register_address: "Register Address: ",
      invoice_register_mobile: "Register Phone: ",
      invoice_branch: "Bank Branch: ",
      invoice_accountno: "Bank Account: ",
      pay_method_title: "Payment Method",
      online_pay: "Online Payment",
      pay_support: "Supports",
      pay1: "WeChat",
      pay2: "Alipay",
      pay3: "Online Payment",
      product_list_title: "Product List",
      back_to_cart: "Return to cart to modify >>",
      th_item_info: "Product",
      th_spec_param: "Specs/Params",
      th_unit_price: "Unit Price",
      th_quantity: "Quantity",
      th_subtotal: "Subtotal",
      remarks_title: "Purchase Remarks",
      delivery_date_label: "Expected Delivery Date: ",
      delivery_option_all: "Weekdays and weekends accepted",
      delivery_option_weekday: "Weekdays only",
      purchase_order_no_label: "Purchase Order No: ",
      purchase_order_placeholder:
        "Please fill in your company standard purchase order number",
      memo_label: "Memo: ",
      memo_placeholder:
        "Please fill in purchase memo; suggest confirming with customer service first",
      attachments_label: "Attachments: ",
      update_tip:
        "(Supports jpeg, jpg, png formats, up to {max} files, each smaller than {size})",
      total_count: "Total Items: ",
      total_amount_label: "Total Amount (incl. tax): ",
      total_tax_label: "Tax: ",
      freight_label: "Freight: ",
      total_pay_label: "Total Payable (incl. tax): ",
      submit_btn: "Submit Order",
      confirm_delete_receive: "Confirm delete this shipping info?",
      confirm_set_default: "Confirm set this shipping address as default?",
      confirm_title: "Notice",
      confirm_confirm: "Confirm",
      confirm_cancel: "Cancel",
      image_type_error: "Invalid image type!",
      image_size_error: "Image size must not exceed 5MB!",
      image_max_error: "You can upload up to {max} images!",
      submitting: "Placing order...",
    },
    detail: {
      home: "Home",
      collect: "Add to favorites",
      collected: "Favorited",
      model_label: "Model: ",
      material_label: "Material: ",
      size_label: "Size: ",
      eva_count: "{count} reviews",
      description: "Description: ",
      spec_label: "Specification: ",
      rechoose: "Rechoose",
      price_unit:"$",
      unit_price_label: "Unit Price (excl. tax): ",
      total_price_excl: "Total (excl. tax): ",
      total_price_incl: "Total (incl. tax): ",
      expected_ship_label: "Estimated Shipping Date: ",
      days_text: "{num} days",
      logistics_price: "Starting price: Delivery for orders over ¥300",
      product_catalog: "Product Catalog:",
      download_btn: "Click to download",
      pay_method_label: "Payment Method: ",
      wechat: "WeChat",
      alipay: "Alipay",
      online_pay: "Online Payment",
      add_to_cart: "Add to Cart",
      buy_now: "Buy Now",
      wholesale_note:
        "Wholesale: For bulk purchases, please contact {online_service}",
      online_service: "online support",
      more_products: "More Products",
      rating_label: "Rating: {score} pts",
      table_title: "Model & Specification",
      operation: "Actions",
      choose: "Choose",
      chosen: "Chosen",
      product_details: "Product Details",
      product_reviews: "Reviews ({count})",
      select_model_first: "Please select a model first",
    },
    download: {
      sort_title: "Home  >  Sample Downloads",
      all_list: "All Categories",
      page_title: "Sample Downloads",
      search_placeholder: "Please enter keywords",
      search_btn: "Search",
      download_btn: "Download",
    },
    forget: {
      tab_verify: "Identity Verification",
      tab_reset: "Reset Password",
      tab_done: "Done",
      label_mobile: "Mobile",
      placeholder_mobile: "Please enter mobile number",
      label_code: "Verification Code",
      placeholder_code: "Please enter verification code",
      get_code: "Get Code",
      re_send_seconds: "Resend in {count} seconds",
      next: "Next",
      label_newpwd: "New Password",
      placeholder_newpwd: "Please enter new password",
      label_confirmpwd: "Confirm Password",
      placeholder_confirmpwd: "Please re-enter new password",
      confirm: "Confirm",
      success_text: "Password changed successfully",
      auto_redirect: "Auto redirect to login in {count}s",
      go_login: "Go to Login",
      msg_enter_mobile: "Please enter mobile number",
      msg_enter_code: "Please enter verification code",
      msg_newpwd_required: "New password is required",
      msg_confirmpwd_required: "Confirm password is required",
      msg_reset_success: "Password reset successful",
    },
    guide: {
      left_title: "Usage Guide",
      menu: {
        personal_center: "Personal Center",
        new_user_guide: "New User Guide",
        delivery_policy: "Delivery Policy",
        after_sales: "After-sales",
        faq: "FAQ",
        about_us: "About Us",
        register: "How to Register",
        agreement: "User Agreement",
        privacy_policy: "Privacy Policy",
        forget: "Forgot Password",
        to_buy: "How to Order",
        to_pay: "How to Pay",
        to_search_order: "View Order Progress",
        shipping_fee: "Shipping Fee Policy",
        shipping_instructions: "Shipping & Delivery",
        sale_policy: "After-sales Policy",
        invoice_apply: "How to Apply for Invoice",
        invoice_search: "How to View Invoice",
        platform: "Platform Introduction",
        contact: "Contact Us",
      },
      register_title: "How to Register",
      register_content:
        "ROKE registration guide: follow the prompts, enter your phone number and company info, verify and complete registration.",
      agreement_title: "User Agreement",
      agreement_content:
        "User Agreement: Please read and comply with registration and service terms.",
      privacy_policy_title: "Privacy Policy",
      privacy_policy_content:
        "Privacy Policy: How we collect, use, store and protect personal information.",
      forget_title: "Forgot Password",
      forget_content:
        "Password recovery: verify via phone and code, then set a new password.",
      to_buy_title: "How to Order",
      to_buy_content:
        "Ordering guide: login → find products → add to cart → submit order → pay.",
      to_pay_title: "How to Pay",
      to_pay_content:
        "Payment guide: supports WeChat, Alipay, and bank transfers. Keep payment proof.",
      to_search_order_title: "View Order Progress",
      to_search_order_content:
        "Order tracking: view orders in Personal Center and follow shipping status.",
      shipping_fee_title: "Shipping Fee Policy",
      shipping_fee_content:
        "Shipping fees: calculated based on final paid amount; return shipping depends on reason.",
      shipping_instructions_title: "Shipping & Delivery",
      shipping_instructions_content:
        "Delivery times: in-stock and custom items have different lead times; 15:00 cutoff on working days.",
      sale_policy_title: "After-sales Policy",
      sale_policy_content:
        "After-sales: return/exchange/refund rules and processing steps.",
      invoice_apply_title: "How to Apply for Invoice",
      invoice_apply_content:
        "Invoice application: apply in Personal Center; enterprises provide taxpayer ID.",
      invoice_search_title: "How to View Invoice",
      invoice_search_content:
        "Invoice viewing: download electronic invoices from My Invoices in Personal Center.",
      platform_title: "Platform Introduction",
      platform_content:
        "Platform intro: ROKE is a digital marketplace for hydraulic parts and supply-chain services.",
      contact_title: "Contact Us",
      contact_content:
        "Contact: Phone 86-513-85400443, email admin@ntroke.com, hours 8:30-17:30.",
    },
  },
  mypages: {
    addresses: {
      title: "Address Management",
      createdPrefix: "You have created ",
      createdSuffix: " addresses",
      add: "Add Address",
      th_recipient: "Recipient",
      th_phone: "Phone",
      th_address: "Address",
      th_action: "Action",
      default_label: "Default",
      edit: "Edit",
      delete: "Delete",
      confirm_delete: "Confirm delete this shipping info?",
      confirm_title: "Notice",
      confirm_confirm: "Confirm",
      confirm_cancel: "Cancel",
    },
    afterSale: {
      title: "My After-sales",
      label_platform_order_no: "Platform Order No:",
      placeholder_platform_order_no: "Please enter platform order no",
      label_product_name: "Product Name:",
      placeholder_product_name: "Please enter product name",
      label_service_no: "After-sales No:",
      placeholder_service_no: "Please enter service no",
      label_apply_time: "After-sales Apply Time:",
      search: "Search",
      reset: "Reset",
      th_service_no: "After-sales No",
      th_platform_order_no: "Platform Order No",
      th_product_name: "Product Name",
      th_spec: "Specification",
      th_buy_quantity: "Purchase Qty",
      th_after_quantity: "After-sales Qty",
      th_action_status: "Action/Status",
      refunded: "Refunded",
      exchanged: "Exchanged",
    },
    applyInvoice: {
      title: "My Orders",
      tab_pending: "Pending Invoices",
      tab_applying: "Applying",
      label_platform_order_no: "Platform Order No:",
      placeholder_platform_order_no: "Please enter platform order no",
      label_purchase_order_no: "Purchase Order No:",
      placeholder_purchase_order_no: "Please enter purchase order no",
      label_order_time: "Order Time:",
      search: "Search",
      reset: "Reset",
      th_platform_order_no: "Platform Order No",
      th_order_time: "Order Time",
      th_purchase_order_no: "Purchase Order No",
      th_buyer: "Buyer",
      th_order_amount: "Order Amount (incl. tax)",
      th_action: "Action",
      btn_apply_invoice: "Apply Invoice",
    },
    collections: {
      title: "My Favorites",
      th_image: "Product Image",
      th_brand_name: "Brand / Name",
      th_description: "Product Description",
      th_price: "Price",
      th_fav_time: "Favorite Time",
      th_action: "Action",
      add_to_cart: "Add to Cart",
      delete: "Delete",
      confirm_delete: "Confirm remove this product from favorites?",
      confirm_title: "Notice",
      confirm_confirm: "Confirm",
      confirm_cancel: "Cancel",
    },
    comments: {
      title: "My Reviews",
      tab_to_comment: "Items to Review",
      tab_commented: "Reviewed Items",
      th_order_detail: "Order Details",
      th_quantity: "Quantity",
      th_amount: "Amount",
      th_recipient: "Recipient",
      th_action: "Action",
      platform_order_no: "Platform Order No: ",
      purchase_order_no: "Purchase Order No: ",
      order_time: "Order Time: ",
      btn_review_now: "Review Now",
      btn_order_detail: "Order Details",
      text_commented: "Reviewed",
      btn_view_review: "View Review",
    },
    history: {
      title: "Browsing History",
      th_image: "Product Image",
      th_brand_name: "Brand / Name",
      th_description: "Product Description",
      th_price: "Price",
      th_view_time: "View Time",
      th_action: "Action",
      add_to_cart: "Add to Cart",
      delete: "Delete",
      confirm_delete_msg: "Confirm remove this product from browsing history?",
      confirm_title: "Notice",
      confirm_ok: "Confirm",
      confirm_cancel: "Cancel",
    },
    invoiceInfo: {
      title: "Invoice Information",
      label_invoice_type: "Invoice Type:",
      tab_short_special: "S",
      tab_special: "Special Invoice",
      tab_short_general: "G",
      tab_general: "General Invoice",
      invoice_head: "Invoice Title:",
      invoice_taxno: "Taxpayer ID:",
      invoice_branch: "Bank Branch:",
      invoice_accountno: "Bank Account:",
      invoice_register_address: "Register Address:",
      invoice_register_mobile: "Register Phone:",
      edit: "Edit",
    },
    invoices: {
      title: "My Invoices",
      label_invoice_no: "Invoice No:",
      placeholder_invoice_no: "Please enter invoice no",
      label_platform_order_no: "Platform Order No:",
      placeholder_platform_order_no: "Please enter platform order no",
      label_purchase_order_no: "Purchase Order No:",
      placeholder_purchase_order_no: "Please enter purchase order no",
      label_invoice_time: "Invoice Time:",
      search: "Search",
      reset: "Reset",
      th_invoice_no: "Invoice No",
      th_invoice_time: "Invoice Time",
      th_invoice_amount: "Invoice Amount (incl. tax)",
      th_platform_order_no: "Platform Order No",
      th_purchase_order_no: "Purchase Order No",
      th_action: "Action",
      btn_download: "Download Invoice",
    },
    messages: {
      title: "Messages Overview",
      mark_all_read: "Mark all read",
      tab_1_month: "Messages within 1 month",
      tab_3_months: "Messages within 3 months",
      tab_1_year: "Messages within 1 year",
      tab_3_years: "Messages within 3 years",
    },
    myInfo: {
      title: "My Information",
      section_personal: "Personal Information",
      username_label: "Username:",
      nickname_label: "Name:",
      email_label: "Email:",
      gender_label: "Gender:",
      gender_male: "Male",
      gender_female: "Female",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      section_security: "Account Security",
      login_password_label: "Login Password:",
      modify: "Modify",
      password_change_advice:
        "It's recommended to change your password regularly to protect account security",
      bind_phone_label: "Bound Phone:",
      phone_lost_advice:
        "If your phone is lost or deactivated, please replace it promptly",
      account_security_title: "Account & Security",
      set_password: "Set Password",
      label_verify_code: "Verification Code:",
      placeholder_enter_code: "Enter verification code",
      get_code: "Get Code",
      reSendSeconds: "Resend in {count} seconds",
      label_password: "Password:",
      placeholder_enter_password: "Enter password",
      label_confirm_password: "Confirm Password:",
      placeholder_confirm_password: "Please re-enter password",
      modify_phone_title: "Change Phone Number",
      step_verify_sms: "SMS Verification",
      step_change_phone: "Change to New Phone",
      step_done: "Done",
      bind_phone_label: "Bound Phone:",
      label_sms_code: "SMS Code:",
      placeholder_enter_smscode: "Please enter the SMS code",
      verify_next: "Verify and proceed to next",
      label_new_phone: "New Phone Number:",
      placeholder_new_phone: "Please enter new phone number",
      submit: "Submit",
      bind_account: "Bind Email",
      validation: {
        checkcode_required: "Verification code is required",
        newpassword_required: "New password is required",
        confirmpwd_required: "Confirm password is required",
      },
      password_change_success: "Password changed successfully",
      password_change_failed: "Failed to change password",
      enter_old_smscode: "Please enter the SMS code from your old phone",
      enter_newphone: "Please enter the new phone number",
      enter_newsmscode: "Please enter the new phone verification code",
      phone_update_success: "Phone updated successfully",
      placeholder_captcha: "Please enter the calculation result on the right",
      change_image: "Change image",
      enter_captcha: "Please enter the captcha",
    },
    order: {
      title: "My Orders",
      tab_all: "All Orders",
      tab_pending_payment: "Pending Payment",
      tab_pending_ship: "Pending Shipment",
      tab_pending_receive: "Pending Receipt",
      tab_completed: "Completed",
      label_platform_order_no: "Platform Order No:",
      placeholder_platform_order_no: "Please enter platform order no",
      label_product_name: "Product Name:",
      placeholder_product_name: "Please enter product name",
      label_purchase_order_no: "Purchase Order No:",
      placeholder_purchase_order_no: "Please enter purchase order no",
      label_order_time: "Order Time:",
      search: "Search",
      reset: "Reset",
      header_order_info: "Order Info",
      header_spec: "Specification",
      header_quantity: "Quantity",
      header_total_amount: "Total Amount",
      header_status: "Order Status",
      header_action: "Action",
      platform_order_no: "Platform Order No: ",
      purchase_order_no: "Purchase Order No: ",
      order_time: "Order Time: ",
      recipient: "Recipient: ",
      invoice_title: "Invoice Title: ",
      status_pending_payment: "Pending Payment",
      status_pending_ship: "Pending Shipment",
      status_pending_receive: "Pending Receipt",
      status_received: "Received",
      status_cancelled: "Cancelled",
      view_detail: "View Details",
      pay_now: "Pay Now",
      cancel_order: "Cancel Order",
      add_to_cart: "Add to Cart",
      confirm_receive: "Confirm Receipt",
    },
    orderDetail: {
      title: "Order Details",
      platform_order_no: "Platform Order No: ",
      pay_method: "Payment Method:",
      pay_online: "Online Payment",
      order_status: "Order Status:",
      section_receive_info: "Receive Information",
      label_recipient: "Recipient: ",
      label_recipient_phone: "Phone: ",
      label_recipient_address: "Address: ",
      section_invoice_info: "Invoice Information",
      label_invoice_type: "Invoice Type:",
      label_invoice_head: "Invoice Title:",
      label_tax_no: "Tax No:",
      section_remark: "Remarks",
      label_expect_delivery: "Expected Delivery:",
      delivery_all_days: "Weekdays and weekends accepted",
      delivery_workday_only: "Weekdays only",
      label_purchase_order_no: "Purchase Order No: ",
      label_order_memo: "Order Memo:",
      memo_none: "None",
      label_attachments: "Attachments",
      th_product_info: "Product",
      th_spec: "Specification",
      th_lead_time: "Lead Time",
      th_quantity: "Quantity",
      th_subtotal_incl_tax: "Subtotal (incl. tax)",
      th_status: "Status",
      lead_time_contact: "Contact customer service for lead time",
      settlement_total_count: "Total Items:",
      settlement_total_amount: "Total Amount (incl. tax):",
      settlement_tax: "Tax:",
      settlement_shipping: "Shipping:",
      settlement_payable: "Total Payable (incl. tax):",
      btn_pay_now: "Pay Now",
    },
    compayInfo: {
      title: "Company Information",
      enterprise_label: "Enterprise Name:",
      contact_name_label: "Contact Name:",
      contact_mobile_label: "Contact Phone:",
      email_label: "Email Address:",
      address_label: "Detailed Address:",
      placeholder_province: "Please select province",
      placeholder_city: "Please select city",
      placeholder_area: "District/County/Street",
      placeholder_address: "Please fill in the office detailed address",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
    },
  },
  common: {
    switch: "Change Language",
  },
};
